import $ from 'jquery';
const showPublications = (searchTerm = '', year = '', all = 'true') =>{
    const holder = document.querySelector('.ume-publications-holder');
    let group = '';
    if(holder !== undefined && holder !== null){
        group = holder.getAttribute('data-pub-group')
    }
    let allPubButtons = document.querySelectorAll('.ume-publications-year-select-button');
    if(allPubButtons.length > 0){
        allPubButtons.forEach(b => {
            b.disabled = true;
        })
    }
    let searchButton = document.querySelector('.ume-starter-pub-search');
    if(searchButton !== null && searchButton !== undefined){
        searchButton.disabled = true;
    }
    const data = {
        action: 'get_publications',
        ume_nonce: wp_environment.ume_nonce,
        search: searchTerm,
        year: year,
        all: all,
        group: group,
       // specificPost: postID,

    };
    $.post(wp_environment.ume_ajax_url, data, function (response) {

        if (response) {

            $('.ume-publications-holder').html('');
            $('.ume-publications-holder').append(response);
            if(year !== ''){
                $('.ume-publications-holder').find(`[data-target-year="${year}"]`).focus();
            }
            if(searchButton !== null && searchButton !== undefined){
                searchButton.disabled = false;
            }
        }

    })


}
$(document).ready(function () {
    if (document.querySelector('.ume-publications-holder')) {

        showPublications('', '', 'false');

    }
    $('.ume-starter-pub-search').click(function (event) {

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        let searchTerm = $('.ume-starter-pub-search').parent().prev('input').val();
        //const targetGrid = document.querySelector('.ume-publications-holder');
        // const parent = targetGrid.parentElement;
        // targetGrid.setAttribute('data-searched', 'true');

        showPublications(searchTerm, '');


    })
    $(document).on('click', '.ume-publications-year-select-button', (event) =>{

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        let theYear = event.target.innerHTML;
        let parent = event.target.closest('.ume-publications-holder');
        parent.setAttribute('data-active-year', theYear );

        showPublications('', theYear, 'false');

    })
    $(document).on('click', '.ume-publications-year-reset-button', (event) =>{

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        $('.ume-starter-pub-search').parent().prev('input').val('');


        showPublications('', '', 'false');

    })
    $(document).on('click', '.ume-publications-show-all', (event) =>{

        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }
        let holder = event.target.closest('.container').querySelector('.ume-publications-year-select-holder');
        let year = event.target.closest('.ume-publications-holder').getAttribute('data-active-year');
        if(year == null || ''){

            let active = holder.firstElementChild.innerHTML;
            year = active;
        }



        showPublications('', year, 'true');

    })
});
export default showPublications;